// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"ecef2989","142":"05859370","296":"35b7a2f0","329":"aecec26a","364":"a91e0b50","493":"a6b247df","856":"2cd04302"}[chunkId] + ".js";
};